class SensenMainCart {
  constructor() {
    this.container = document.querySelector('.sensen-cart-section');
    if (!this.container) return;

    this.debounceTimer = null;
    this.init();
  }

  init() {
    this.container.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('[data-sensen-cart-qty-btn]');
      if (qtyBtn) {
        this.handleQtyBtn(qtyBtn);
        return;
      }

      const removeBtn = e.target.closest('[data-sensen-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        this.handleRemove(removeBtn);
        return;
      }

      const discountBtn = e.target.closest('[data-sensen-cart-discount-apply]');
      if (discountBtn) {
        e.preventDefault();
        this.applyDiscountCode();
        return;
      }
    });

    this.container.addEventListener('change', (e) => {
      const qtyInput = e.target.closest('[data-sensen-cart-qty-input]');
      if (qtyInput) {
        clearTimeout(this.debounceTimer);
        this.handleQtyInput(qtyInput);
        return;
      }
    });

    this.container.addEventListener('keydown', (e) => {
      const qtyInput = e.target.closest('[data-sensen-cart-qty-input]');
      if (qtyInput && e.key === 'Enter') {
        e.preventDefault();
        qtyInput.blur();
      }

      const discountInput = e.target.closest('[data-sensen-cart-discount-input]');
      if (discountInput && e.key === 'Enter') {
        e.preventDefault();
        this.applyDiscountCode();
      }
    });

    this.container.addEventListener('input', (e) => {
      const qtyInput = e.target.closest('[data-sensen-cart-qty-input]');
      if (qtyInput) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.handleQtyInput(qtyInput);
        }, 600);
      }
    });
  }

  async applyDiscountCode() {
    const input = this.container.querySelector('[data-sensen-cart-discount-input]');
    const applyBtn = this.container.querySelector('[data-sensen-cart-discount-apply]');
    const msgContainer = this.container.querySelector('[data-sensen-cart-discount-msg]');
    if (!input) return;
    const code = input.value.trim();
    if (!code) return;

    try {
      if (applyBtn) {
        applyBtn.disabled = true;
        const btnSpan = applyBtn.querySelector('span');
        if (btnSpan) btnSpan.textContent = 'Sprawdzanie...';
      }
      if (msgContainer) {
        msgContainer.textContent = '';
        msgContainer.className = 'sensen-cart-discount-msg';
      }
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.location.pathname)}`;
    } catch (err) {
      if (applyBtn) {
        applyBtn.disabled = false;
        const btnSpan = applyBtn.querySelector('span');
        if (btnSpan) btnSpan.textContent = 'Zastosuj';
      }
      if (msgContainer) {
        msgContainer.textContent = 'Nie udało się zastosować kodu rabatowego.';
        msgContainer.className = 'sensen-cart-discount-msg is-error';
      }
    }
  }

  updateQuantityButtons(picker) {
    if (!picker) return;
    const minus = picker.querySelector('[data-quantity-minus]');
    const plus = picker.querySelector('[data-quantity-plus]');
    const input = picker.querySelector('.sensen-quantity-input');
    if (!minus || !plus || !input) return;

    const val = parseInt(input.value, 10) || 1;
    const maxAttr = input.getAttribute('max');
    const maxVal = maxAttr ? parseInt(maxAttr, 10) : null;

    minus.disabled = val <= 1;
    plus.disabled = maxVal !== null ? val >= maxVal : false;
  }

  async handleQtyBtn(btn) {
    if (btn.disabled) return;
    const picker = btn.closest('.sensen-quantity-picker');
    const input = picker?.querySelector('.sensen-quantity-input');
    const lineKey = btn.getAttribute('data-line-key') || input?.getAttribute('data-line-key');
    const lineIndex = btn.getAttribute('data-line-index') || input?.getAttribute('data-line-index');
    if (!input || !lineKey) return;

    const change = parseInt(btn.getAttribute('data-change'), 10) || 0;
    const currentVal = parseInt(input.value, 10) || 1;
    const maxAttr = input.getAttribute('max');
    const maxVal = maxAttr ? parseInt(maxAttr, 10) : null;

    let newVal = currentVal + change;
    if (newVal < 1) newVal = 1;
    if (maxVal !== null && newVal > maxVal) newVal = maxVal;

    if (newVal === currentVal) {
      this.updateQuantityButtons(picker);
      return;
    }

    input.value = newVal;
    this.updateQuantityButtons(picker);
    const actionType = change > 0 ? 'plus' : 'minus';
    await this.updateCartLine(lineKey, newVal, lineIndex, { lineKey, actionType });
  }

  async handleQtyInput(input) {
    const picker = input.closest('.sensen-quantity-picker');
    const lineKey = input.getAttribute('data-line-key');
    const lineIndex = input.getAttribute('data-line-index');
    if (!lineKey) return;

    const maxAttr = input.getAttribute('max');
    const maxVal = maxAttr ? parseInt(maxAttr, 10) : null;
    const currentCartQty = parseInt(input.getAttribute('data-cart-qty') || input.defaultValue || 1, 10);

    let val = parseInt(input.value, 10);
    if (isNaN(val)) return;

    if (val < 1) val = 1;
    if (maxVal !== null && val > maxVal) val = maxVal;

    input.value = val;
    this.updateQuantityButtons(picker);

    if (val === currentCartQty) {
      return;
    }

    input.setAttribute('data-cart-qty', val);
    await this.updateCartLine(lineKey, val, lineIndex, { lineKey, actionType: 'input' });
  }

  async handleRemove(btn) {
    const lineKey = btn.getAttribute('data-line-key');
    const lineIndex = btn.getAttribute('data-line-index');
    if (!lineKey) return;

    const card = btn.closest('.sensen-cart-item-card');
    if (card) {
      card.classList.add('is-removing');
    }

    await this.updateCartLine(lineKey, 0, lineIndex);
  }

  async updateCartLine(lineKey, quantity, lineIndex, focusTarget = null) {
    try {
      const bodyPayload = { quantity: quantity };
      if (lineIndex) {
        bodyPayload.line = parseInt(lineIndex, 10);
      } else {
        bodyPayload.id = lineKey;
      }

      const sectionId = this.container.closest('.shopify-section')?.id?.replace('shopify-section-', '') || 'sensen-main-cart';
      bodyPayload.sections = [sectionId];
      bodyPayload.sections_url = window.location.pathname;

      const res = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyPayload)
      });

      if (!res.ok) throw new Error('Cart update failed');
      const data = await res.json();

      if (data.sections && data.sections[sectionId]) {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data.sections[sectionId], 'text/html');
        const newCartSec = htmlDoc.querySelector('.sensen-cart-section');

        if (newCartSec) {
          this.container.replaceChildren(...newCartSec.childNodes);

          if (focusTarget && focusTarget.lineKey) {
            let elToFocus = null;
            if (focusTarget.actionType === 'plus') {
              elToFocus = this.container.querySelector(`[data-line-key="${focusTarget.lineKey}"][data-quantity-plus]`);
            } else if (focusTarget.actionType === 'minus') {
              elToFocus = this.container.querySelector(`[data-line-key="${focusTarget.lineKey}"][data-quantity-minus]`);
            } else if (focusTarget.actionType === 'input') {
              elToFocus = this.container.querySelector(`[data-line-key="${focusTarget.lineKey}"][data-sensen-cart-qty-input]`);
            }

            if (elToFocus) {
              elToFocus.focus();
            }
          }
        }
      } else {
        window.location.reload();
        return;
      }

      if (window.pubsub && window.PUB_SUB_EVENTS) {
        window.pubsub.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sensen-main-cart', cart: data });
      }
    } catch (err) {
      window.location.reload();
    }
  }
}

const initSensenMainCart = () => {
  if (!window.sensenMainCart) {
    window.sensenMainCart = new SensenMainCart();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSensenMainCart);
} else {
  initSensenMainCart();
}
